let HeaderLocationOne = {
  name:"管理平台首页",
  href:"#"
};

let HeaderLocationTwo = {
  name:"注册会员资料管理",
  href:"/user/list"
};

let HeaderLocationThree = {
  name:"注册会员资料列表",
  href:""
};

let loginInfo= {
  isLogin: false,
  jwtToken: null
};

export default{
  HeaderLocationOne,
  HeaderLocationTwo,
  HeaderLocationThree,
  loginInfo
}



// export function setHeaderLocationOne(obj) {
//   HeaderLocationOne = obj;
// }
//
// export function setHeaderLocationTwo(obj) {
//   HeaderLocationTwo = obj;
// }
//
// export function setHeaderLocationThree(obj) {
//   HeaderLocationThree = obj;
// }
